import { render, staticRenderFns } from "./ModalWizard.vue?vue&type=template&id=0a08ffdf&"
import script from "./ModalWizard.vue?vue&type=script&lang=js&"
export * from "./ModalWizard.vue?vue&type=script&lang=js&"
import style0 from "./ModalWizard.vue?vue&type=style&index=0&id=0a08ffdf&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a08ffdf')) {
      api.createRecord('0a08ffdf', component.options)
    } else {
      api.reload('0a08ffdf', component.options)
    }
    module.hot.accept("./ModalWizard.vue?vue&type=template&id=0a08ffdf&", function () {
      api.rerender('0a08ffdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/ModalWizard.vue"
export default component.exports